import { gsap } from "gsap";
import { ScrollTrigger, ScrollSmoother } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollSmoother);

ScrollTrigger.config({ ignoreMobileResize: true });

const scroller = ScrollSmoother.create({
    smooth: 0.7,
    effects: true,
});

const header = document.querySelector("#header");
const headerHeight = header.offsetHeight;
const changeColor = document.querySelector("body.blue") == null;

// HEADER TRANSITION FROM TRANSPARENT ON SCROLL
document.addEventListener("scroll", () => {
    const header = document.querySelector("#header");

    if (header && changeColor) {
        if (window.scrollY > 1) {
            header.classList.add("bg-transparentwhite", "backdrop-blur-sm");
        } else {
            header.classList.remove("bg-transparentwhite", "backdrop-blur-sm");
        }
    }

    if (header && !changeColor) {
        if (window.scrollY > 1) {
            header.classList.add("backdrop-blur-sm");
        } else {
            header.classList.remove("backdrop-blur-sm");
        }
    }
});

// Mobile remove fixed header at footer
// const box = document.querySelector('#header');

// gsap.to('#header', {
// 	scrollTrigger: {
// 		trigger: '#footer',
// 		start: () => '0 ' + box.offsetHeight,
// 		end: () => box.offsetHeight + ' ' + box.offsetHeight,
// 		scrub: 0,
// 	},
// 	y: () => {
// 		return -box.offsetHeight;
// 	},
// 	ease: 'none',
// });

// Anchor
gsap.utils.toArray("a.anchor").forEach(function (button, i) {
    button.addEventListener("click", (e) => {
        // const headerHeight = window.innerWidth < 768 ? "80px" : "112px";
        var id = e.target.getAttribute("href");

        if (id) {
            scroller.scrollTo(id, true, `top ${headerHeight}`);
        } else {
            var alt = e.target.parentNode.getAttribute("href");
            scroller.scrollTo(alt, true, `top ${headerHeight}`);
        }
        e.preventDefault();
    });
});

// Transcript Anchor
gsap.utils.toArray("a.toc-anchor").forEach(function (button, i) {
    button.addEventListener("click", (e) => {
        // const headerHeight = "112px";
        var id = e.target.getAttribute("href");

        if (id) {
            setTimeout(() => {
                scroller.scrollTo(id, true, `top ${headerHeight}`);
            }, 200);
        } else {
            var alt = e.target.parentNode.getAttribute("href");
            setTimeout(() => {
                scroller.scrollTo(alt, true, `top ${headerHeight}`);
            }, 200);
        }
        e.preventDefault();
    });
});

window.onload = (event) => {
    let urlHash = window.location.href.split("#")[1];
    let scrollElem = document.querySelector("#" + urlHash);
    // const headerHeight = window.innerWidth < 768 ? "80px" : "112px";

    if (urlHash && scrollElem) {
        gsap.to(scroller, {
            scrollTop: scroller.offset(scrollElem, `top ${headerHeight}`),
            duration: 1,
            delay: 0.5,
        });
    }
    scroller.refresh();
};

// Object.freeze(scroller);

export { scroller };
